import { EntityDefinition } from '@/types/crud';

export const abacActionEntity: EntityDefinition = {
  name: 'abacAction',
  displayName: 'Actions',
  apiEndpoint: '/generic/abac_actions',
  idField: 'id',
  nameField: 'action_name',
  copyable: false,
  deletable: true,
  searchable: true,
  sortable: true,
  pageSize: 20,
  tableColumns: [
    {
      key: 'action_name',
      label: 'Action Name',
      sortable: true,
      render: (value: any) => value || 'N/A'
    },
    {
      key: 'action_code',
      label: 'Action Code',
      sortable: true,
      render: (value: any) => value || 'N/A'
    },
    {
      key: 'description',
      label: 'Description',
      sortable: false,
      render: (value: any) => value ? (value.length > 50 ? value.substring(0, 50) + '...' : value) : 'N/A'
    },
    {
      key: 'resource_type',
      label: 'Resource Type',
      sortable: true,
      render: (value: any) => value || 'N/A'
    },
    {
      key: 'category',
      label: 'Category',
      sortable: true,
      render: (value: any) => value || 'N/A'
    },
    {
      key: 'is_system_action',
      label: 'System Action',
      sortable: true,
      render: (value: any) => value ? 'Yes' : 'No'
    },
    {
      key: 'is_active',
      label: 'Active',
      sortable: true,
      render: (value: any) => value ? 'Yes' : 'No'
    }
  ],
  fields: [
    {
      key: 'id',
      label: 'ID',
      type: 'text',
      hidden: true,
      order: 0
    },
    {
      key: 'action_name',
      label: 'Action Name',
      type: 'text',
      required: true,
      placeholder: 'Enter action name',
      order: 1
    },
    {
      key: 'action_code',
      label: 'Action Code',
      type: 'text',
      required: true,
      placeholder: 'Enter action code (e.g., KPI_CREATE)',
      order: 2
    },
    {
      key: 'description',
      label: 'Description',
      type: 'textarea',
      placeholder: 'Enter description',
      order: 3
    },
    {
      key: 'resource_type',
      label: 'Resource Type',
      type: 'select',
      required: true,
      options: [
        { value: 'GENERAL', label: 'General' },
        { value: 'KPI', label: 'KPI' },
        { value: 'TRANSFORMATION', label: 'Transformation' },
        { value: 'USER', label: 'User' },
        { value: 'TENANT', label: 'Tenant' },
        { value: 'PROCESS', label: 'Process' },
        { value: 'REPORT', label: 'Report' },
        { value: 'DASHBOARD', label: 'Dashboard' },
        { value: 'ABAC_POLICY', label: 'ABAC Policy' },
        { value: 'ABAC_ATTRIBUTE', label: 'ABAC Attribute' },
        { value: 'SYSTEM', label: 'System' },
        { value: 'NAVIGATION', label: 'Navigation' }
      ],
      order: 4
    },
    {
      key: 'category',
      label: 'Category',
      type: 'select',
      required: true,
      options: [
        { value: 'CRUD', label: 'CRUD Operations' },
        { value: 'OPERATIONS', label: 'Operations' },
        { value: 'WORKFLOW', label: 'Workflow' },
        { value: 'ADMIN', label: 'Administration' },
        { value: 'UI', label: 'User Interface' }
      ],
      order: 5
    },
    {
      key: 'is_system_action',
      label: 'System Action',
      type: 'boolean',
      defaultValue: false,
      order: 6
    },
    {
      key: 'is_active',
      label: 'Active',
      type: 'boolean',
      defaultValue: true,
      order: 7
    },
    {
      key: 'created_by_email',
      label: 'Created By',
      type: 'text',
      readOnly: true,
      formHidden: true,
      order: 8
    },
    {
      key: 'created_at',
      label: 'Created',
      type: 'datetime',
      readOnly: true,
      formHidden: true,
      order: 9
    }
  ]
};
